import { Metrics } from '../metrics';
import { persistedFetchFrameworkTypes } from 'fdsr-migration-layer';
import { isEarlyCacheReturnEnabled } from '../earlyCacheReturn';
export { persistedFetchFrameworkTypes };
export const makeFrameworkTypesClient = ({
  httpClient,
  persistedPromise = persistedFetchFrameworkTypes
}) => {
  const getForFamily = ({
    family
  }) => persistedPromise.makeFetchWithOpts({
    allowEagerCacheReturn: isEarlyCacheReturnEnabled()
  })({
    family,
    httpClient
  });
  return Promise.resolve({
    /**
     * Prints debug info to the console.
     */
    debug: () => {
      persistedPromise.debug();
    },
    /**
     * Clears internal cache state
     *
     * @returns A promise which resolves when state is clear.
     */
    clearCache: () => {
      persistedPromise.clearCache();
      return Promise.resolve();
    },
    /**
     * Gets all event type definitions in this portal.
     *
     * @param options.__isComposed For internal metrics tracking purposes only. Set to true when called within another client method.
     * @returns A promise which resolves to all event types, or null if the data could not be found.
     */
    getEvents: ({
      __isComposed = false
    } = {}) => {
      if (!__isComposed) {
        Metrics.counter('frameworkTypes.getEvents').increment();
      }
      return getForFamily({
        family: 'events'
      });
    },
    /**
     * Gets all object type definitions in this portal.
     *
     * @param options.__isComposed For internal metrics tracking purposes only. Set to true when called within another client method.
     * @returns A promise which resolves to all object types, or null if the data could not be found.
     */
    getObjects: ({
      __isComposed = false
    } = {}) => {
      if (!__isComposed) {
        Metrics.counter('frameworkTypes.getObjects').increment();
      }
      return getForFamily({
        family: 'objects'
      });
    }
  });
};